import React, { useContext, useEffect } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  StyleSheet
} from 'react-native';
import { colors } from '../context/Colors';
import AppContext from '../context';
import Icon from 'react-native-vector-icons/Ionicons';
import { useColorScheme } from 'react-native-appearance';
import { useNavigation, useRoute } from '@react-navigation/native';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import InventoryObjectThumb from '../components/InventoryObjectThumb';
import { View as DView } from 'dripsy';
dayjs.extend(relativeTime);

export default function Inventory() {
  const navigation = useNavigation();
  const theme = useColorScheme() === 'dark' ? 'dark' : 'light';
  const route = useRoute();
  const { tour, setTour, dict } = useContext(AppContext);

  useEffect(() => {
    tour.badgeInventory = 0;
    setTour({ ...tour });
  }, []);

  return (
    <View
      style={{
        padding: 10,
        borderRadius: 10
      }}
      onLayout={(e) => {
        // console.log('LAYOUT');
        // setGameMenuHeight(
        //   Math.min(
        //     e.nativeEvent.layout.height,
        //     Dimensions.get('screen').height - 110
        //   )
        // );
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TouchableOpacity
          style={{ padding: 10, marginLeft: -10 }}
          onPress={() => navigation.goBack()}
        >
          <Icon name="chevron-back" color={colors[theme].text} size={22} />
        </TouchableOpacity>
        <Text
          style={{
            color: colors[theme].text,
            fontSize: 19,
            fontWeight: '600',
            flex: 1,
            textAlign: 'center'
          }}
        >
          {route.params.type === 'inventory' ? dict.inventory : null}
          {route.params.type === 'puzzles' ? dict.jigsaw_puzzle : null}
          {route.params.type === 'letters' ? dict.mystery_word : null}
        </Text>
        <View style={{ width: 34 }} />
      </View>
      <ScrollView>
        <View>
          {tour[route.params.type].map((i, k) => (
            <View key={k}>
              <TouchableOpacity
                style={[
                  styles.box,
                  { backgroundColor: colors[theme].gameButtonBg }
                ]}
                onPress={() => navigation.navigate('InventoryDetail', { i })}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      <InventoryObjectThumb o={i} />
                      <View
                        style={{
                          marginLeft: 10,
                          marginRight: 50
                        }}
                      >
                        <Text
                          style={{
                            color: colors[theme].text,
                            fontSize: 18,
                            fontWeight: '600',
                            flex: 1
                          }}
                        >
                          {i.objectName}
                        </Text>
                        <Text
                          style={{
                            opacity: 0.5,
                            fontSize: 12,
                            marginTop: 20,
                            color: colors[theme].text
                          }}
                        >
                          {dayjs(i.time).fromNow()}, stop {i.fromStop + 1}
                        </Text>
                      </View>
                    </View>
                    {i.objectType === 'Object' && i.enablePhotoWithObject && (
                      <View style={{ marginTop: 20, flexDirection: 'row' }}>
                        <TouchableOpacity
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center'
                          }}
                          onPress={() =>
                            navigation.navigate('Camera', { artifact: i })
                          }
                        >
                          <Icon
                            name="camera-reverse-outline"
                            size={16}
                            color={colors[theme].text}
                          />
                          <Text
                            style={{
                              color: colors[theme].text,
                              fontSize: 12,
                              marginLeft: 2
                            }}
                          >
                            {dict.take_a_photo}
                          </Text>
                        </TouchableOpacity>
                      </View>
                    )}
                  </View>
                  <Icon
                    name="chevron-forward"
                    size={16}
                    color={colors[theme].text}
                  />
                </View>
              </TouchableOpacity>
            </View>
          ))}
        </View>
        <View
          style={{
            borderWidth: 2,
            borderColor: colors[theme].gamePreamble,
            flexDirection: 'row',
            marginTop: 10,
            marginHorizontal: 5,
            alignItems: 'center',
            borderRadius: 8,
            backgroundColor: colors[theme].gamePreamble
          }}
        >
          <View
            style={{
              backgroundColor: colors[theme].bg,
              padding: 8,
              marginRight: 10,
              borderTopLeftRadius: 8,
              borderBottomLeftRadius: 8
            }}
          >
            <Icon
              name="information-circle-outline"
              size={24}
              color={colors[theme].text}
              style={{ opacity: 0.4 }}
            />
          </View>
          <Text
            style={{
              color: colors[theme].text,
              opacity: 0.4,
              fontSize: 12,
              fontWeight: '600'
            }}
          >
            {route.params.type === 'inventory'
              ? Number(tour.totalInventory - tour.inventory.length) +
                ' ' +
                dict.items_to_be_discovered
              : null}
            {route.params.type === 'puzzles'
              ? Number(tour.totalPuzzles - tour.puzzles.length) +
                ' ' +
                dict.puzzles_to_be_discovered
              : null}
            {route.params.type === 'letters'
              ? Number(tour.totalLetters - tour.letters.length) +
                ' ' +
                dict.letters_to_be_discovered
              : null}
          </Text>
        </View>
        <View style={{ height: 50 }} />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    borderRadius: 8,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    flex: 1,
    margin: 7
  }
});
